import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Goal as GoalModel } from '@feathr/blackbox';
import { Alert, CurrencyEntry } from '@feathr/components';

import { shouldRender } from './ConversionValueEntry.utils';

import * as styles from './ConversionValueEntry.css';

interface IProps {
  goal: GoalModel;
}

function ConversionValueEntry({ goal }: Readonly<IProps>): JSX.Element | null {
  const { t } = useTranslation();

  if (!shouldRender({ goal })) {
    return null;
  }

  function handleChangeValue(value: number): void {
    goal.set({ conv_value: value });
  }

  const shouldShowAlert = goal.get('conv_value') === undefined || goal.get('conv_value') === 0;

  return (
    <>
      <CurrencyEntry
        description={t('Enter the monetary value of this goal. ')}
        label={t('Conversion value')}
        onChange={handleChangeValue}
        optional={true}
        tooltip={t(
          'For goals with direct value (like registrations), use that amount. For goals without direct monetary value (audience growth, engagement), use a small meaningful value between $1-$10.',
        )}
        value={goal.get('conv_value')}
      />
      {shouldShowAlert && (
        <Alert
          className={styles.alert}
          description={t(
            'Setting a monetary value helps you track and measure the ROI of this goal more accurately.',
          )}
          title={t('Add a conversion value')}
          type={'warning'}
        />
      )}
    </>
  );
}

export default observer(ConversionValueEntry);
